<template>
  <div id="service">
    <a-popover placement="left">
      <template #content>
        <div class="qrcode">
          <img :src="service_QRcode" alt="">
          <span>微信扫码添加助教</span>
          <span>进入专属答疑群</span>
        </div>
      </template>
      <div class="service_btn">
        <img :src="icon_service" alt="">
        <span>助教</span>
      </div>
    </a-popover>
  </div>
</template>

<script>
  import {BackTop, popover} from "ant-design-vue";
  export default {
    name: "Service",
    components: {
      [popover.name]: popover,
    },
    data(){
      return{
        icon_service: require("@/assets/img/icon_service.png"),
        service_QRcode: require("@/assets/img/service_QRcode.jpg"),
      }
    },
    methods: {},
    mounted() {
    },
  }
</script>

<style scoped lang="scss">
  .service_btn{
    width: 48px;
    height: 48px;
    right: 2vw;
    top: 0;
    bottom: 0;
    margin: auto;
    position: fixed;
    cursor: pointer;
    border-radius: 6px;
    background: linear-gradient(180deg,#def2ff,#fbfdff);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 1;
    img{
      width: 40%;
      margin-bottom: 4px;
      display: block;
    }
    span{
      font-size: 12px;
      color: #0581ce;
    }
  }
  .qrcode{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: -8px -12px;
    img{
      width: 100px;
    }
    span{
      font-size: 14px;
    }
  }
</style>
